import React from 'react';
import PropTypes from 'prop-types';
import { NO_DESKTOP_APP, MESSENGER_BRANDS, AVAILABLE_MESSENGERS } from '../constants';
import { __t } from '@mssgme/shared';
// import { isMobile } from '@mssgme/helpers';
import Brand from '../Brand';
import styles from './Header.module.scss';

const Header = ({ messenger }) => {
    // const hasDesktopApp = NO_DESKTOP_APP.indexOf(messenger) < 0;
    // const { label, color, downloadUrl } = MESSENGER_BRANDS[messenger];

    return (
        <header className={styles.root}>
            <div className={styles.brand}>
                <Brand messenger={messenger} />
            </div>
            {/* {!isMobile() && hasDesktopApp && (
                <div className={styles.download} style={{ backgroundColor: color }}>
                    <a href={downloadUrl} target="_blank" rel="noreferrer noopener">
                        {__t('not_have', [label])} <strong>{__t('download_it')}</strong>
                    </a>
                </div>
            )} */}
        </header>
    );
};

Header.propTypes = {
    messenger: PropTypes.oneOf(AVAILABLE_MESSENGERS).isRequired,
};

export default Header;
